import { roundDateDownToNearest15MinIncrement, dateFromSecondsTimestamp, dateToTimeString, goDateString } from "./common";
import { displayTimeRangeTooltip } from './summary_dws';
import { calculateSlotMarginAndWidth, setSlotMarginAndWidth } from './summary_dws_slot_render_helpers';
import { OPLUS_COLOR_PALETTE, SLOT_TYPES } from "./models";
import { tableDates } from './summary_dws_table'
import { toOplusTime } from "../common/common";

export function close(slot) {
  $(".slots-cont.draggable").resizable("enable");
  $(".sections-overlay").addClass("drag-handle");
  $(".draw-sections").removeClass('active');
  $(".slot").removeClass('draw-sections-active');
  $(".section-alert").show();

  $(document).off('mousemove');
  $(document).off('mouseup');
  if (slot) {
    $(`#temp-section-${slot.ID}`).remove();
  }
}

function getStartAndEndDateForDraw(slot) {
  let startDate = dateFromSecondsTimestamp(slot.FromUnix);
  let endDate = dateFromSecondsTimestamp(slot.ToUnix);
  if (slot.HideFrom || isSlotStartOutsideTable(slot)) {
    startDate = toOplusTime(tableDates[0].getDate());
  }

  if (slot.HideTo) {
    endDate = toOplusTime(tableDates[tableDates.length - 1].getEnd());
  }

  return { startDate, endDate }
}

function isSlotStartOutsideTable(slot) {
  return new Date(slot.From).getTime() < toOplusTime(tableDates[0].getDate()).getTime();
}

export function getMouseDownDateForSectionDraw(slot, relativeLeft) {
  const { startDate, endDate } = getStartAndEndDateForDraw(slot);

  const startInSec = startDate.getTime() / 1000;
  const endInSec = endDate.getTime() / 1000;
  return dateFromSecondsTimestamp((relativeLeft * (endInSec - startInSec)) + startInSec);
}

export function handleSectionDrawMouseDown(event) {
  const delta = 6; // threshold (px) to determine if the action is a click or drag
  const startX = event.pageX;
  const startY = event.pageY;

  const drawSectionsEl = $(event.target);
  const slotId = drawSectionsEl.parents('.slot').data('id');
  const slot = SlotMap[slotId];
  const role = App.roles.find(r => r.ID === selectedTemplate.id);
  const relativeLeft = event.originalEvent.layerX / $(event.target).innerWidth();
  const mouseDownDate = getMouseDownDateForSectionDraw(slot, relativeLeft);
  const { startDate, endDate } = getStartAndEndDateForDraw(slot);
  roundDateDownToNearest15MinIncrement(mouseDownDate);
  const to = new Date(mouseDownDate);
  // Set initial To time to be 15 minutes after From time.
  to.setUTCMinutes(to.getUTCMinutes() + 15, 0, 0);
  drawSectionsEl.append(createTempSectionDOMElementFromRole(role, slot));
  const {relativeMarginLeft, relativeSlotWidth, relativeMarginRight} = calculateSlotMarginAndWidth(
    {
      from: mouseDownDate,
      to
    },
    {
      from: startDate,
      to: endDate,
    },
  )
  const selector = `#temp-section-${slot.ID}`;
  setSlotMarginAndWidth(selector, relativeMarginLeft, relativeSlotWidth, relativeMarginRight);
  displayTimeRangeTooltip($(event.target).parents('.slot'), dateToTimeString(mouseDownDate), dateToTimeString(to));

  $(document).on('mousemove', (mouseMoveEvent) => handleSectionDrawMouseMove(mouseDownDate, slot, event, mouseMoveEvent));
  // reset existing "mouseup" event
  $(document).on('mouseup', (mouseUpEvent) => {
    const diffX = Math.abs(mouseUpEvent.pageX - startX);
    const diffY = Math.abs(mouseUpEvent.pageY - startY);
    // Click
    if (diffX < delta && diffY < delta) {
      handleSectionMouseUp(slot, role, mouseDownDate);
    // Drag
    } else {
      handleSectionDrawMouseUp(mouseDownDate, slot, role, event, mouseUpEvent);
    }
  });

}

function calculateSectionDrawFromAndTo(event, mouseDownEvent, slot, mouseDownDate) {
  const drawSectionsTarget = $(mouseDownEvent.target);
  const {left, _} = drawSectionsTarget.offset();
  const drawSectionsWidth = drawSectionsTarget.width()
  const drawSectionsRight = left + drawSectionsWidth;
  const mousePositionX = event.originalEvent.clientX;
  // this returns 0 when slot type is 1 or more, unable to add sections properly, TODO: Fix
  const { startDate, endDate } = getStartAndEndDateForDraw(slot);
  const slotLengthInSeconds = (endDate.getTime() - startDate.getTime()) / 1000;
  let from = mouseDownDate;
  let to;
  if (mousePositionX >= drawSectionsRight) {
    to = endDate;
  } else if (mousePositionX <= left) {
    from = startDate;
    to = mouseDownDate;
  } else {
    const relativeSectionRight = (drawSectionsRight - mousePositionX) / drawSectionsWidth;
    to = dateFromSecondsTimestamp((startDate.getTime() / 1000) + ((1 - relativeSectionRight) * slotLengthInSeconds));
    roundDateDownToNearest15MinIncrement(to);
    // If we start dragging from right to left, then switch the From and To
    if (to < from) {
      from = to;
      to = mouseDownDate;
    }
  }
  return {from, to};
}

function handleSectionDrawMouseMove(mouseDownDate, slot, mouseDownEvent, mouseMoveEvent) {
  const {from, to} = calculateSectionDrawFromAndTo(mouseMoveEvent, mouseDownEvent, slot, mouseDownDate);
  const { startDate, endDate } = getStartAndEndDateForDraw(slot);
  const {relativeMarginLeft, relativeSlotWidth, relativeMarginRight} = calculateSlotMarginAndWidth(
    {
      from,
      to,
    },
    {
      from: startDate,
      to: endDate,
    },
  );
  const selector = `#temp-section-${slot.ID}`;
  setSlotMarginAndWidth(selector, relativeMarginLeft, relativeSlotWidth, relativeMarginRight);
  displayTimeRangeTooltip($(mouseDownEvent.target).parents('.slot'), dateToTimeString(from), dateToTimeString(to));

}

function handleSectionDrawMouseUp(mouseDownDate, slot, role, mouseDownEvent, mouseUpEvent) {
  const {from, to} = calculateSectionDrawFromAndTo(mouseUpEvent, mouseDownEvent, slot, mouseDownDate);
  const data = createSectionData(from, to, slot, role);
  close(slot);
  sectionSubmitSummary(true, data);
}

export function handleSectionMouseUp(slot, role, mouseDownDate, toDate, isTemplateRole = true, section = null) {
  let mouseUpDate = new Date(mouseDownDate)
  if (toDate) {
    mouseUpDate = toDate;
  } else {
    mouseUpDate.setUTCHours(mouseUpDate.getUTCHours() + 1, mouseUpDate.getUTCMinutes(), 0, 0);
  }

  let data;
  if (section) {
    data = createSectionDataFromExisting(mouseDownDate, mouseUpDate, slot.ID, role, section)
  } else {
    data = createSectionData(mouseDownDate, mouseUpDate, slot, role);
  }

  close(slot);

  return sectionSubmitSummary(true, data, undefined, isTemplateRole);
}

function createSectionData(fromDate, toDate, slot, role) {
  const data = {
    "from"        : dateToTimeString(fromDate),
    "to"          : dateToTimeString(toDate),
    "comID"       : slot.CompanyID,
    "parent"      : slot.ID,
    "purpose"     : role.Purpose || role.Name,
    "roleID"      : role.ID,
    "roleName"    : role.Name,
    "color"       : role.Color || OPLUS_COLOR_PALETTE.DEFAULT,
    "date"        : goDateString(fromDate),
    "type"        : role.Type,
    "locked"      : false,
    "rest"        : "",
    "restSection" : role.SlotType == SLOT_TYPES.OFF_DAY || role.SlotType == SLOT_TYPES.PTO,
    "sendEmail"   : false,
    "fromDate"    : goDateString(fromDate),
    "SlotType"    : role.SlotType,
  };

  return data;
}

// Used for creating data from existing sections (not from a template)
function createSectionDataFromExisting(fromDate, toDate, slotId, role = {}, section) {
  const data = {
    "from"        : dateToTimeString(fromDate),
    "to"          : dateToTimeString(toDate),
    "comID"       : section.CompanyID,
    "parent"      : slotId,
    "purpose"     : section.Purpose || role.Purpose || role.Name,
    "roleID"      : role.ID || "",
    "roleName"    : role.Name || "",
    "color"       : section.Color || role.Color || OPLUS_COLOR_PALETTE.DEFAULT,
    "date"        : goDateString(fromDate),
    "type"        : section.Type,
    "locked"      : section.Locked || false,
    "rest"        : section.Rest || "",
    "restSection" : section.Type === SLOT_TYPES.SECTION_REST || role.SlotType == SLOT_TYPES.OFF_DAY || role.SlotType == SLOT_TYPES.PTO,
    "sendEmail"   : false,
    "fromDate"    : goDateString(fromDate),
    "memo"        : section.Memo || "",
  };

  return data;
}

function createTempSectionDOMElementFromRole(role, slot) {
  const isDefaultRoleColor = !role.Color || role.Color === OPLUS_COLOR_PALETTE.DEFAULT;
  return `
    <div
        class="section temp-section"
        data-section="true"
        style="${!isDefaultRoleColor ? `background-color: #${ role.Color }; color:white;` : ''}"
        id="temp-section-${slot.ID}"
    >
      <div class="title-outer">
        <p>
          <small class="section-title" data-text="name">
            ${ role.Type == SLOT_TYPES.SECTION_REST && role.Name === "" ? "休憩" : role.Name }
          <\x2Fsmall>
        <\x2Fp>
      <\x2Fdiv>
    <\x2Fdiv>
  `
}

export function initSectionDrawOnSlot(slot) {
  const drawSections = $(`#slot-${slot.ID}`).find('.draw-sections');
  drawSections.on('mousedown', (e) => handleSectionDrawMouseDown(e));
  drawSections.on('click', (e) => e.stopPropagation());
}

export function initSectionDraw() {
  $('.draw-sections').on('mousedown', (e) => handleSectionDrawMouseDown(e));
  // Block click events from opening slot modal
  $('.draw-sections').on('click', (e) => e.stopPropagation());
}
